import { render, staticRenderFns } from "./MeasurementFieldEditor.vue?vue&type=template&id=2270c7f6"
import script from "./MeasurementFieldEditor.vue?vue&type=script&lang=js"
export * from "./MeasurementFieldEditor.vue?vue&type=script&lang=js"
import style0 from "./MeasurementFieldEditor.vue?vue&type=style&index=0&id=2270c7f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports